module.exports = __webpack_public_path__ + "static/media/partner6.965488bb.png";